import React from "react";
import Icon from "../Icon";
import "./styles.scss";

const STATUS = {
    CONNECTED: "connected",
    CONNECTING: "connecting",
    DISCONNECTED: "disconnected",
    PARTIALLY_CONNECTED: "partially_connected",
};

export const StatusBadge = ({ status, isConnecting = false, className = "" }) => {
    const getStatusClass = () => {
        if (status === STATUS.CONNECTING) return "connecting";
        if (status === STATUS.CONNECTED) return "connected";
        if (status === STATUS.PARTIALLY_CONNECTED) return "partially-connected";
        return "disconnected";
    };

    const getStatusText = () => {
        if (status === STATUS.CONNECTING) return "Conectando";
        if (status === STATUS.CONNECTED) return "Conectado";
        if (status === STATUS.PARTIALLY_CONNECTED) return "Parcialmente conectado";
        return "Não conectado";
    };

    const renderIcon = () => {
        if (status === STATUS.CONNECTING) {
            return (
                <div className="status-badge__loading">
                    <div className="status-badge__spinner" />
                </div>
            );
        }
        if (status === STATUS.CONNECTED) return <Icon name="connected" size={14} />;
        if (status === STATUS.PARTIALLY_CONNECTED) return <Icon name="alert" size={14} />;
        return <Icon name="disconnected" size={14} />;
    };

    const statusClass = getStatusClass();

    return (
        <div className={`status-badge status-badge--${statusClass} ${className}`.trim()}>
            {renderIcon()}
            <span>{getStatusText()}</span>
        </div>
    );
};

export default StatusBadge;
